import { apiGet, apiDelete, apiGetBlob } from './api'
import type { Document } from '../types'

export const documentApi = {
  getByProject(projectId?: string): Promise<Document[]> {
    if (projectId) {
      return apiGet<Document[]>(`/documents/project/${projectId}`)
    }
    return apiGet<Document[]>('/documents')
  },

  upload(projectId: string, file: File, category?: string, description?: string): Promise<Document> {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('projectId', projectId)
    if (category) formData.append('category', category)
    if (description) formData.append('description', description)

    const API_BASE = import.meta.env.VITE_API_URL || '/api'
    return fetch(`${API_BASE}/documents/upload`, {
      method: 'POST',
      body: formData,
    }).then(async (res) => {
      if (!res.ok) throw new Error(`Upload failed: ${res.status}`)
      return res.json() as Promise<Document>
    })
  },

  download(id: string): Promise<Blob> {
    return apiGetBlob(`/documents/${id}/download`)
  },

  delete(id: string): Promise<void> {
    return apiDelete(`/documents/${id}`)
  },
}
